export const MAX_TASK_ATTACHMENT_BYTES = 20 * 1024 * 1024

export const TASK_ATTACHMENT_ACCEPT = [
  'image/*',
  '.heic',
  '.heif',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.txt',
  '.csv',
  '.mp4',
  '.mov'
].join(',')

export type TaskAttachmentKind = 'image' | 'pdf' | 'video' | 'spreadsheet' | 'document' | 'presentation' | 'text' | 'file'

const EXTENSION_KINDS: Record<string, TaskAttachmentKind> = {
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  webp: 'image',
  bmp: 'image',
  svg: 'image',
  pdf: 'pdf',
  mp4: 'video',
  mov: 'video',
  xls: 'spreadsheet',
  xlsx: 'spreadsheet',
  csv: 'spreadsheet',
  doc: 'document',
  docx: 'document',
  ppt: 'presentation',
  pptx: 'presentation',
  txt: 'text'
}

export function getTaskAttachmentKind(filename: string, mimetype = ''): TaskAttachmentKind {
  const dot = filename.lastIndexOf('.')
  const extension = dot === -1 ? '' : filename.slice(dot + 1).toLowerCase()
  if (EXTENSION_KINDS[extension]) return EXTENSION_KINDS[extension]
  if (mimetype.startsWith('image/')) return 'image'
  if (mimetype.startsWith('video/')) return 'video'
  if (mimetype === 'application/pdf') return 'pdf'
  if (mimetype.startsWith('text/')) return 'text'
  return 'file'
}

export const TASK_ATTACHMENT_ICONS: Record<TaskAttachmentKind, string> = {
  image: 'mdi:file-image-outline',
  pdf: 'mdi:file-pdf-box',
  video: 'mdi:file-video-outline',
  spreadsheet: 'mdi:file-excel-outline',
  document: 'mdi:file-word-outline',
  presentation: 'mdi:file-powerpoint-outline',
  text: 'mdi:file-document-outline',
  file: 'mdi:file-outline'
}

export function isTaskAttachmentWithinLimit(size: number): boolean {
  return size <= MAX_TASK_ATTACHMENT_BYTES
}

export function formatFileSize(bytes: number): string {
  if (!bytes || bytes < 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB']
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit++
  }
  const rounded = unit === 0 || value >= 10 ? Math.round(value) : Math.round(value * 10) / 10
  return `${rounded} ${units[unit]}`
}

export function taskAttachmentURL(storagePath: string, taskID: string, filename: string): string {
  return `${storagePath}/tasks/${taskID}/${filename}`
}

export function isPublicURL(url: string): boolean {
  try {
    const { protocol, hostname } = new URL(url)
    if (protocol !== 'http:' && protocol !== 'https:') return false
    if (hostname === 'localhost' || hostname.endsWith('.local') || hostname === '[::1]') return false
    if (/^(127\.|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|0\.)/.test(hostname)) return false
    return true
  } catch {
    return false
  }
}
